import React, { MouseEventHandler } from 'react';
import { DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { Button } from '@katalon-studio/katalon-ui';
import CloseableDialogComponent from './CloseableDialogComponent';
import { t } from '../../i18n/t';

interface ConfirmDeleteDialogProps {
    isOpen: boolean;
    handleClose: MouseEventHandler;
    handleConfirm: MouseEventHandler;
    title?: string;
    message: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

export function ConfirmDeleteDialog({
  isOpen,
  handleClose,
  handleConfirm,
  title = t('delete#title'),
  message,
  confirmButtonText = t('confirm'),
  cancelButtonText = t('cancel'),
}: Readonly<ConfirmDeleteDialogProps>) {
  return (
    <CloseableDialogComponent
      isOpen={isOpen}
      handleClose={handleClose}
      maxWidth="sm"
      title={title}
    >
      <DialogContent>
        <DialogContentText className="title ml-0 mt-3 text-left">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="popup-footer justify-content-end p-0">
        <Button
          id="button-cancel"
          color="secondary"
          variant="contained"
          className="ml-3 btn-secondary"
          size="small"
          disableElevation
          onClick={handleClose}
        >
          {cancelButtonText}
        </Button>
        <Button
          id="button-confirm"
          variant="contained"
          color="error"
          size="small"
          disableElevation
          onClick={handleConfirm}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </CloseableDialogComponent>
  );
}
